import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { AUDIENCE_LABELS } from '@/lib/howItWorksContent';
import { HOW_IT_WORKS } from '@/constants/testIds';

const itemBase =
  'px-4 py-2 rounded-lg text-sm text-[hsl(var(--lxra-muted))] transition-colors duration-150 ' +
  'data-[state=on]:text-[hsl(var(--lxra-fg))] data-[state=on]:bg-[hsl(var(--lxra-gold)/0.14)] ' +
  'data-[state=on]:border data-[state=on]:border-[hsl(var(--lxra-gold)/0.35)] ' +
  'hover:text-[hsl(var(--lxra-fg))] focus-visible:outline-none focus-visible:ring-2 ' +
  'focus-visible:ring-[hsl(var(--lxra-gold)/0.55)] focus-visible:ring-offset-2 focus-visible:ring-offset-[hsl(var(--lxra-bg))]';

// Switches the copy shown throughout the timeline / voice guide between the
// client and photographer perspective. Layout never changes, only wording.
export const AudienceToggle = ({ value, onChange, className = '' }) => {
  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={(next) => next && onChange(next)}
      data-testid={HOW_IT_WORKS.audienceToggle}
      className={`inline-flex rounded-xl border border-[hsl(var(--lxra-border))] bg-[hsl(var(--lxra-bg-2))] p-1 ${className}`}
    >
      <ToggleGroupItem value="client" data-testid={HOW_IT_WORKS.audienceClient} className={itemBase}>
        {AUDIENCE_LABELS.client}
      </ToggleGroupItem>
      <ToggleGroupItem value="photographer" data-testid={HOW_IT_WORKS.audiencePhotographer} className={itemBase}>
        {AUDIENCE_LABELS.photographer}
      </ToggleGroupItem>
    </ToggleGroup>
  );
};
